<template>
  <birthday-layout @on-scroll="handleScroll" :enable-scroll-event="true" id="board-index">
    <div>
      <BoardContent
        ref="boardContent"
        v-if="this.isYearSelected"
        class="board-content-offset"
        @set-debounce="setDebounce"
      />
      <BoardYearContent v-else class="year-content-offset" />
      <WriteMessageButton />
    </div>
  </birthday-layout>
</template>

<script>
import { mapState } from 'vuex';
import BirthdayLayout from '@/components/BirthdayLayout.vue';
import BoardContent from '@/components/Board/Main/BoardContent';
import BoardYearContent from '@/components/Board/Main/BoardYearContent';
import WriteMessageButton from '@/components/Board/Main/WriteMessageButton';
import { isIosNativeOnly } from '@/utils/platform-check';

export default {
  components: {
    BoardContent,
    BoardYearContent,
    WriteMessageButton,
    BirthdayLayout,
  },
  data() {
    return {
      debounce: false,
    };
  },
  computed: {
    ...mapState('board', ['currBoard', 'isYearSelected']),
  },
  async ionViewWillEnter() {
    this.$store.dispatch('board/updateShowOptionsModal', false);
    this.$store.dispatch('board/updateShowFilterModal', false);
    await this.$store.dispatch('updates/getUpdates', 'all');
    if (this.isYearSelected && this.$refs.boardContent) {
      this.$refs.boardContent.refreshPosts();
    }
  },
  methods: {
    isIos() {
      return isIosNativeOnly();
    },
    async handleScroll($event) {
      if (this.debounce) return;
      const scrollElement = await $event.target.getScrollElement();
      if (
        scrollElement.clientHeight + scrollElement.scrollTop >=
        (scrollElement.scrollHeight || scrollElement.clientHeight)
      ) {
        this.debounce = true;
        await this.$refs.boardContent.loadMorePosts();
      }
    },
    setDebounce(value) {
      this.debounce = value;
    },
  },
};
</script>

<style scoped>
/* Driven by --board-fixed-height set in BirthdayLayout via ResizeObserver.
   Fallback includes safe-area-inset-top for iPhones before JS fires. */
.board-content-offset {
  padding-top: var(--board-fixed-height, calc(152px + env(safe-area-inset-top, 0px)));
}
.year-content-offset {
  padding-top: var(--board-fixed-height, calc(64px + env(safe-area-inset-top, 0px)));
}
</style>
